"use client"

import { useState, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import Image from 'next/image'
import logo from "../../../public/heelio_logo.png";
import picture from "../../../public/hero.svg";
import Fade from 'react-reveal/Fade';



export default function Hero() {


  return (
    <div className="bg-[#FAFAFA] text-[#042040]">

      <div className="relative isolate pl-2 sm:pl-6 pt-14 xl:pl-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
        </div>
        <div className="mx-auto pt-10 flex flex-wrap xl:flex-nowrap justify-between items-center overflow-hidden">

          <div className="text-left pl-2 md:pl-5 w-full xl:w-1/2 grow">
            <div className='overflow-hidden'>
              <Fade bottom>
                <h1 className=" text-3xl sm:text-4xl font-bold tracking-tight text-[#042040] md:text-6xl lg:text-7xl">
                  {/*Votre entreprise,*/}
                  La direction financière
                </h1>
              </Fade>
            </div>
            
            <div className='overflow-hidden pb-5 pr-5 pt-2'>
              <Fade bottom delay={200}>
                <h1  className="block xl:hidden relative text-3xl sm:text-4xl font-bold tracking-tight text-[#042040] md:text-6xl lg:text-7xl relative">pour les&nbsp;
                <p className="relative inline-block">
                    <span className="bg-[#FED90F] w-[210px] sm:w-[250px] md:w-[420px] lg:w-[500px] h-10 md:h-16 lg:h-20 absolute top-0 -left-1 z-1 rounded-lg transform rotate-[-1.5deg]"></span>
                    <span className="relative">entrepreneurs</span>
                  </p> 
                </h1>

                <h1  className="hidden xl:block relative text-3xl sm:text-4xl font-bold tracking-tight text-[#042040] md:text-6xl lg:text-7xl relative">pour les&nbsp;
                <p className="relative inline-block ml-2">
                    <span className="bg-[#FED90F] w-[250px] md:w-[420px] lg:w-[500px] h-10 md:h-16 lg:h-20 absolute top-0 -left-1 z-1 rounded-lg transform rotate-[-1.5deg]"></span>
                    <span className="relative">entrepreneurs</span>
                  </p> 
                </h1>
              </Fade>
            </div>

              <p className="whitespace-nowrap mt-6 text-sm sm:text-lg md:text-xl leading-4 md:leading-8 text-gray-600">
                L&apos;alliance d&apos;experts et d&apos;une technologie pointue
              </p>

              <p className="whitespace-nowrap text-sm sm:text-lg md:text-xl leading-8 text-gray-600">
                pour un suivi financier précis, réactif et sur-mesure 
              </p>

            <div className='flex justify-start items-center gap-5 sm:gap-10 mt-10 flex-col sm:flex-row'>
               
              <div className='fadeIn relative w-fit h-fit group cursor-pointer'>
                  <div className='absolute top-0 left-0 rounded-md bg-[#FED90F66] w-full h-full transform translate-x-2 translate-y-2 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500'></div>
                  
                  <div className="z-10 w-fit rounded-md px-3.5 py-2.5 border border-1 border-[#042040] relative transform translate-y-0 translate-x-0 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500">
                      <a
                          href="https://zcal.co/heelio/decouverte"
                          target='_blank'
                          rel="noopener noreferrer"
                          className=" w-full h-full rounded-md text-sm font-bold tracking-wider text-[#042040] "
                      >
                          Réserver votre démo
                      </a>
                  </div>
              </div>

              <div className='fadeIn relative w-fit h-fit group cursor-pointer'>
                  
                  <div className="z-10 w-fit py-1 border-b-2 border-[#FED90F33] hover:border-[#FED90F] relative transform translate-y-0 translate-x-0 ease-in-out duration-500">
                      <a
                          href="https://zcal.co/heelio/consultation"
                          target='_blank'
                          rel="noopener noreferrer"
                          className=" w-full h-full rounded-md text-sm font-bold tracking-wider text-[#042040] "
                      >
                          Prendre RDV avec un DAF*
                      </a>
                  </div>
              </div>

            </div>
            
            
            <Fade bottom>
              <p className='font-extralight text-xs md:text-sm mt-5 max-w-2/3'>*Consultation gratuite : conseil sur votre environnement et vos problématiques financières</p>
            </Fade>
            
            
          </div>
          
          <Image src={picture} alt="dashboard" className='fadeIn w-3/4 xl:w-[45%] mx-auto mt-20 xl:mt-0 pr-5'/>
        </div>
      </div>
    </div>
  )
}
